import { ActivityMachineContext } from "../types";

export const ActivityCommonGuards = {
  isMobile: (ctx: ActivityMachineContext) => ctx.platform === "mobile",
  isDesktop: (ctx: ActivityMachineContext) => ctx.platform === "desktop",
};
